import { _ } from "~/i18n";
import { IMapyBoxItem } from "~/interfaces";
import Dialog from "../dialog";
import { node } from "~/melown3d/utils";
import { folderDelete, likeDelete, trackDelete } from "~/util/providers/mapybox";
import { getMapyboxError, mapyboxNotification } from "~/util/mapybox";

// smazat | odebrat
type TOperation = "delete" | "remove";

interface IMyMapsRempve {
	data: IMapyBoxItem;
	ids?: Array<string>;
	isMultiple?: boolean;
	operation?: TOperation;
	onRemove?: () => void;
}

export function isTrackFromData(data: IMapyBoxItem) {
	return data.type === "track" || (data.type === "link" && data.linktype === "track");
}

// delete - trvale smazat vše
// remove - u tracku smazat pouze polozku, ne celou aktivitu + potomky
export default class MyMapsRemove {
	_opts: IMyMapsRempve;

	_dialog: Dialog;

	constructor(data: IMyMapsRempve) {
		this._opts = {
			operation: "delete",
			ids: [],
			isMultiple: false,
			onRemove: () => {},
			...data,
		};

		this._build();
	}

	open() {
		this._dialog.open();
	}

	destroy() {
		this._dialog.destroy();
	}

	_build() {
		let title = "";
		let descText = "";

		if (this._opts.ids.length > 0) {
			title = _("mymap.delete.multiple");
		} else {
			const itemTitle = this._opts.data.usertitle || this._opts.data.title;
			const isTrack = isTrackFromData(this._opts.data);

			if (isTrack) {
				title = this._opts.operation === "delete"
					? _("mymap.delete.item", { item: itemTitle })
					: _("mymap.remove.fromFolder", { item: itemTitle });
				descText = this._opts.operation === "delete"
					? _("mymap.delete.activity", {
						strongStart: "<strong>",
						strongEnd: "</strong>",
						br: "</br>",
					})
					: _("mymap.remove.activity");
			} else {
				switch (this._opts.data.type) {
					case "folder":
						title = _("mymap.delete.item", { item: itemTitle });
						descText = _("mymap.folder.delete");
						break;

					default:
						title = _("mymap.delete.fromFolder", { item: itemTitle });
				}
			}
		}

		const dialog = new Dialog({
			title,
			className: "mymaps-remove-dialog",
		});

		dialog.setBasic({
			closeTxt: this._opts.operation === "delete"
				? "delete"
				: "remove",
			bindEnter: true,
			cb: () => {
				this._onRemove();
			},
		});



		if (descText) {
			const content = dialog.dom.content;
			const desc = node("p", { innerHTML: descText });

			content.append(desc);
		}

		this._dialog = dialog;
	}

	_onRemove() {
		this._dialog.setError("");
		let prom: Promise<any> = null;

		if (this._opts.ids.length > 0) {
			prom = likeDelete(this._opts.ids);
		} else if (this._opts.data.type === "folder") {
			prom = folderDelete(this._opts.data.id);
		} else if (this._opts.data.linktype === "track") {
			if (this._opts.operation === "delete") {
				prom = trackDelete(this._opts.data.linkid);
			} else {
				prom = likeDelete(this._opts.data.id);
			}
		} else if (this._opts.data.type === "track") {
			prom = trackDelete(this._opts.data.id);
		} else {
			prom = likeDelete([this._opts.data.id]);
		}

		prom.then(() => {
			this._onRemoveSuccess();
		}, () => {
			this._onRemoveError();
		});
	}

	async _onRemoveSuccess() {
		try {
			if (this._opts.data.type === "folder") {
				Mapy.ProviderMapyBox.removeFolderFromCache(this._opts.data.id);
				await Mapy.ProviderMapyBox.folderList();
			} else {
				Mapy.ProviderMapyBox.removeFolderFromCache(this._opts.data.parent_id);
				await Mapy.ProviderMapyBox.folderList(this._opts.data.parent_id);
			}
		} catch (exc) {
			//
		}

		if (this._opts.data.type !== "folder") {
			Mapy.getComponent("places").listRefreshData();
			Mapy.getComponent("places").notifyLikeUpdate();
		}

		// analytika
		if (this._opts.ids.length === 0) {
			Mapy.getComponent("logger").log("my_maps_item_delete", { type: this._opts.data.type });
		}

		Mapy.getComponent("places").updateLikeList();

		mapyboxNotification({
			item: this._opts.data,
			operation: "delete",
			removeItemsLen: this._opts.isMultiple
				? this._opts.ids.length
				: 0,
			isRemove: this._opts.operation === "remove",
		});

		this._dialog.destroy();
		this._opts.onRemove();
	}

	_onRemoveError() {
		const errorMsg = getMapyboxError({
			item: this._opts.data,
			operation: "delete",
			removeItemsLen: this._opts.isMultiple
				? this._opts.ids.length
				: 0,
			isRemove: this._opts.operation === "remove",
		});

		this._dialog.setError(errorMsg);
	}
}
